var map = {
	"./banner/routes.js": 9242,
	"./comment/routes.js": 8629,
	"./magazine/routes.js": 4797,
	"./puzzle/routes.js": 3996,
	"./settings/routes.js": 9616,
	"./user/routes.js": 3711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2510;